import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';

const InviteCustomer = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const [inviteModal, setInviteModal] = useState(false);
    const [data, setData] = useState([]);
    const [dataemp, setDataemp] = useState([]);
    const [errors, setErrors] = useState('');
    
    const userdata1 = localStorage.getItem('USER_data');
    const userData = JSON.parse(userdata1);
    const userid = userData.id;  
    
    const [company, setCompany] = useState([]);
    useEffect(() => {
        const companyData = localStorage.getItem('companies');
        if (companyData) {
            const parsedData = JSON.parse(companyData);
            const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
            setCompany(singleCompany);
        }
    }, []);
    
    const [hallData, setHallData] = useState({
        Amount: '',
        ExpenseDate: '',
        ExpenseTypeID: '',
        EmployeeID: '',
        CompanyID: company.CompanyID,
        UserID: userid,
        status: '', // أضفنا هذا الحقل لأنه سيتم تخزين النص فيه
    });

    const [selectedTypeName, setSelectedTypeName] = useState(''); // لحفظ اسم النوع المختار
    const [loanText, setLoanText] = useState(''); // لتخزين نص القرض

    useEffect(() => {
        getExpenses();
        fetchEmployees();
    }, []);

    useEffect(() => {
        if (company.CompanyID && userid) {
            setHallData((prevData) => ({
                ...prevData,
                CompanyID: company.CompanyID,
                UserID: userid,
            }));
        }
    }, [company, userid]);

    const fetchEmployees = async () => {
        await axios.get('https://suhba.education.com.ly/back/api/getEmp1')
            .then(({ data }) => {
                setDataemp(data);
            });
    };
    
    const getExpenses = () => {
        axios.get('https://suhba.education.com.ly/back/api/getempexpensestype')
            .then(({ data }) => {
                setData(data.ExpenseType);
            })
            .catch((error) => {
                console.error("Error fetching expense types:", error);
            });
    };

    useImperativeHandle(ref, () => ({
        showInviteModal() {
            setInviteModal(true);
        }
    }));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setHallData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        // إذا كان التغيير في نوع المصروف
        if (name === "ExpenseTypeID") {
            const selected = data.find((row) => row.ExpenseTypeID == value);
            const typeName = selected ? selected.TypeName.toLowerCase() : "";
            setSelectedTypeName(typeName);

            // إذا لم يكن النوع loan، أزل أي نص سابق
            if (typeName !== "سلفة موظف") {
                setLoanText('');
                setHallData((prev) => ({ ...prev, status: '' }));
            }
        }
    };

    // في حال كتب المستخدم نص القرض، نخزن القيمة داخل status
    const handleLoanTextChange = (e) => {
        const text = e.target.value;
        setLoanText(text);
        setHallData((prevData) => ({
            ...prevData,
            status: `سلفة- ${text}`,
        }));
    };

    const handleAmountChange = (e) => {
        setErrors('');
        const { name, value } = e.target;

        if (/^\d*$/.test(value)) {
            setHallData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        } else {
            setErrors("هده الخانه لاتقبل الا الاعداد الصحيحة");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post('https://suhba.education.com.ly/back/api/storeEmployeeExpense', hallData);
            setInviteModal(false);
            props.parentFunction();
            swal("تمت عملية الحفظ بنجاح");

            setHallData({
                Amount: '',
                ExpenseDate: '',
                ExpenseTypeID: '',
                EmployeeID: '',
                CompanyID: company.CompanyID,
                UserID: userid,
                status: '',
            });
            setSelectedTypeName('');
            setLoanText('');
        } catch (error) {
            console.error("Error submitting expense:", error);
        }
    };

    const showInviteModal = () => {
        setInviteModal(false);
    };

    return (
        <>
            <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">إضافة مصروفات الموظف</h1>
                        <button type="button" className="btn-close" style={{ marginLeft: 0 }} onClick={() => setInviteModal(false)}></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <label className="form-label">اختر الموظف<span className="text-danger">*</span></label>
                                            <select className="default-select form-control" name="EmployeeID" value={hallData.EmployeeID} onChange={handleInputChange}>
                                                <option value="">اختر من القائمة</option>
                                                {dataemp.map((row) => (
                                                    <option key={row.EmployeeID} value={row.EmployeeID}>
                                                        {row.FirstName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-xl-6">
                                            <label className="form-label">تاريخ الصرف<span className="text-danger">*</span></label>
                                            <div className="input-group">
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    name="ExpenseDate" 
                                                    value={hallData.ExpenseDate} 
                                                    onChange={handleInputChange} 
                                                />
                                            </div>
                                        </div>

                                        <div className="col-xl-6">
                                            <label className="form-label">القيمة<span className="text-danger">*</span></label>
                                            <div className="input-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    name="Amount" 
                                                    value={hallData.Amount} 
                                                    onChange={handleAmountChange} 
                                                />
                                            </div>
                                            {errors && <div className='alert alert-danger'>{errors}</div>}
                                        </div>
                                    </div>

                                    <div className="col-xl-12">
                                        <label className="form-label mt-3">دالك لــ<span className="text-danger">*</span></label>
                                        <select className="default-select form-control" name="ExpenseTypeID" value={hallData.ExpenseTypeID} onChange={handleInputChange}>
                                            <option value="">اختر من القائمة</option>
                                            {data.map((row) => (
                                                <option key={row.ExpenseTypeID} value={row.ExpenseTypeID}>
                                                    {row.TypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* يظهر هذا الحقل فقط إذا كان النوع هو loan */}
                                    {selectedTypeName === "سلفة موظف" && (
                                        <div className="col-xl-12 mt-3">
                                            <label className="form-label">تفاصيل القرض</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="اكتب تفاصيل القرض..."
                                                value={loanText}
                                                onChange={handleLoanTextChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-primary">حفظ</button>
                            <button type="button" className="btn btn-danger light" onClick={showInviteModal}>إلغاء</button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
});

export default InviteCustomer;
